import { Avatar, Menu, MenuItem, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../redux/actions/authActions";

const Dropdown = ({ element, open, setElement }) => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.Auth);
  return (
    <div>
      <Menu anchorEl={element} open={open} onClose={() => setElement(null)}>
        <MenuItem>
          <Link className="w-full" to="/">
            home
          </Link>
        </MenuItem>
        <MenuItem>
          <Link className="w-full" to={`/profile/${user._id}`}>
            my profile
          </Link>
        </MenuItem>
        <MenuItem>
          <Link className="w-full" to="/check-matches">
            check matches
          </Link>
        </MenuItem>
        <MenuItem onClick={() => dispatch(logout())}>logout</MenuItem>
      </Menu>
    </div>
  );
};

export default Dropdown;
